import { render, staticRenderFns } from "./salesRecord.vue?vue&type=template&id=ee47df2a&scoped=true&"
import script from "./salesRecord.vue?vue&type=script&lang=js&"
export * from "./salesRecord.vue?vue&type=script&lang=js&"
import style0 from "./salesRecord.vue?vue&type=style&index=0&id=ee47df2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee47df2a",
  null
  
)

export default component.exports